import { USBGrid, USBColumn } from '@usb-shield/react-grid/dist/esm';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

const MobileLayout = ({ id, children, enforceNoMargin, ...otherProps }) => {
  var gridClass = classNames('usbbp-viewport', {
    'enforce-nomargin': enforceNoMargin
  });

  return (
    <USBGrid
      className={gridClass}
      gridGap={'normal'}
      addId={id}
      {...otherProps}
    >
      <USBColumn
        layoutOpts={{
          spans: {
            xlarge: 10,
            large: 10,
            medium: 6,
            small: 4,
          },
          offset: {
            xlarge: 3,
            large: 3,
            medium: 1,
          },
        }}
        {...otherProps}
      >
        {children}
      </USBColumn>
    </USBGrid>
  );
};

// MobileLayout.MainLayoutTux=MainLayoutTux;

MobileLayout.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node.isRequired,
  otherProps: PropTypes.any,
  enforceNoMargin: PropTypes.bool
};
MobileLayout.defaultProps = {
  id: '',
  otherProps: {},
  enforceNoMargin: false
};

export default MobileLayout;
